import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const UploadIcon = ({ className }: IProps) => {
  const iconClassName = classNames('upload-icon', className);

  return (
    <svg
      className={iconClassName}
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='20'
      fill='none'
      viewBox='0 0 21 20'
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.8'
        d='M18 14.167l-.745 1.49a3.333 3.333 0 01-2.982 1.843H6.727a3.333 3.333 0 01-2.982-1.842L3 14.167M10.5 12.5v-10L14 6M10.5 2.5L7 6'
      ></path>
    </svg>
  );
};

export default UploadIcon;
